if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener(
					"submit",
					this.onSubmitHandler.bind(this)
				);
				this.cart = document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if ( this.cart )
					this.submitButton.setAttribute("aria-haspopup", "dialog");
				
				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true")
					return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart
							.getSectionsToRender()
							.map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							if (document.querySelector('recipient-form')) document.querySelector('recipient-form').displayErrorMessage(formData.get('id'), response.description, response.message );
							this.handleErrorMessage(response.description);
                            return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}
						if (!this.error && document.querySelector('recipient-form')) document.querySelector('recipient-form').resetRecipientForm( formData.get('id') );
              				
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (
							this.cart &&
							this.cart.classList.contains("is-empty")
						)
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						
						const bundlingAtcButton = this.querySelector('.product__bundling-atc');
        				const bundlingAuickAddButton = this.querySelector('.product__bundling-quick-add');

						if ( bundlingAtcButton ){
							bundlingAtcButton.classList.remove("loading");
							bundlingAtcButton.removeAttribute("aria-disabled")
						}
						if ( bundlingAuickAddButton ){
							bundlingAuickAddButton.classList.remove("loading");
							bundlingAuickAddButton.removeAttribute("aria-disabled")
						}
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute(
					"hidden",
					!errorMessage
				);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
